import React from 'react';
import { employeeCommissionCalculate, employeeCommissionCalculate2, formatToUSD } from './ReusableFunctions';

const Commissions = ({ cisdata = [], targetRow, data, totalTarget, currentFilter }) => {
  function calculateCommissions(cisdata, targetData) {
    const cutoffDate = new Date('2024-06-01');
    const firstEntryDate = new Date(cisdata[0]?.tenderedDate);
    const lastEntryDate = new Date(cisdata[cisdata.length - 1]?.tenderedDate);
    if (firstEntryDate < cutoffDate && lastEntryDate < cutoffDate) {
      return employeeCommissionCalculate(cisdata, targetData);
    } else if (firstEntryDate >= cutoffDate && lastEntryDate >= cutoffDate) {
      return employeeCommissionCalculate2(cisdata, targetData);
    }
  }
  const validCisdata = Array.isArray(cisdata) ? cisdata : [];

  const store = [];
  const reps = [];
  validCisdata?.forEach((item) => {
    if (!store.includes(item.storeInvoice)) store.push(item.storeInvoice);
    if (!reps.includes(item.user)) reps.push(item.user);
  });

  let post = 0;
  let pre = 0;
  let hup = 0;
  let add = 0;
  let ap = 0;

  const calculateAndSetCommissions = (cisdatafinal, targetData) => {
    const result = calculateCommissions(cisdatafinal, targetData);
    post += result?.post || 0;
    pre += result?.pre || 0;
    hup += result?.hup || 0;
    add += result?.addon || 0;
    ap += result?.ap || 0;

  };

  if (store.length < reps.length && currentFilter !== undefined) {
    reps.forEach((item) => {
      const cisdatafinal = cisdata?.filter((item1) => item1.user === item);
      const targetFinal = totalTarget?.filter((item1) => item1.username === item);
      const targetData = targetFinal.reduce((acc, item) => {
        acc.postpaidtarget = (acc.postpaidtarget || 0) + parseInt(item.postpaidtarget);
        acc.prepaidtarget = (acc.prepaidtarget || 0) + parseInt(item.prepaidtarget);
        acc.hardwareupgrade = (acc.hardwareupgrade || 0) + parseInt(item.hardwareupgrade);
        acc.addon = (acc.addon || 0) + parseInt(item.addon); 
        acc.accessories = (acc.accessories || 0) + parseInt(item.accessories);
        acc.applecare = (acc.applecare || 0) + parseInt(item.applecare);
        acc.smssurvey = (acc.smssurvey || 0) + parseInt(item.smssurvey);
       
        return acc;
      }, {});

      calculateAndSetCommissions(cisdatafinal, targetData);
    });
  } else if (reps.length < store.length && currentFilter !== undefined) {
    store.forEach((item) => {
      const cisdatafinal = cisdata?.filter((item1) => item1.storeInvoice === item);
      const targetFinal = totalTarget?.filter(
        (item1) => item1.storeinvoice === item && item1.username === reps[0],
      );
      const targetData = targetFinal.reduce((acc, item) => {
        acc.postpaidtarget = (acc.postpaidtarget || 0) + parseInt(item.postpaidtarget);
        acc.prepaidtarget = (acc.prepaidtarget || 0) + parseInt(item.prepaidtarget);
        acc.hardwareupgrade = (acc.hardwareupgrade || 0) + parseInt(item.hardwareupgrade);
        acc.addon = (acc.addon || 0) + parseInt(item.addon);
        acc.accessories = (acc.accessories || 0) + parseInt(item.accessories);
        acc.applecare = (acc.applecare || 0) + parseInt(item.applecare);
        acc.smssurvey = (acc.smssurvey || 0) + parseInt(item.smssurvey);
        return acc;
      }, {});

      calculateAndSetCommissions(cisdatafinal, targetData);
    });
  } else {
    calculateAndSetCommissions(cisdata, targetRow);
  }

  const commissionFinal = {
    postpaidCommission: post,
    prepaidCommission: pre,
    hupCommission: hup,
    addonCommission: add,
    autopayCommission: ap,
  };

  return (
    <div className="widget">
      <div className="left">
        <span className="title">Postpaid</span>
        <span className="counter">
          {formatToUSD(commissionFinal.postpaidCommission || 0)}
        </span>
      </div>

      <div className="left">
        <span className="title">Prepaid</span>
        <span className="counter">
           {formatToUSD(commissionFinal.prepaidCommission || 0)}
        </span>
      </div>

      <div className="left">
        <span className="title">HUP</span>
        <span className="counter">
            {formatToUSD(commissionFinal.hupCommission || 0)}
   
        </span>
      </div>
 {/* removed autopay from Manager Dashboard until Requirements are
 verified %}
 
      {/*<div className="left">
        <span className="title">AUTOPAY</span>
        <span className="counter">
            {formatToUSD(commissionFinal.autopayCommission || 0)}
   
        </span>
      </div>*/}
      <div className="left">
        <span className="title">Addons</span>
        <span className="counter">
          $0
          {/* {formatToUSD(commissionFinal.addonCommission || 0)}*/}
        </span>
      </div>
      

      <div className="left">
        <span className="title">Total</span>
        <span className="counter">
          {/* $
          {commissionFinal.postpaidCommission +
          commissionFinal.prepaidCommission +
          commissionFinal.hupCommission +
          commissionFinal.autopayCommission +
          commissionFinal.addonCommission
            ? (
                commissionFinal.postpaidCommission +
                commissionFinal.prepaidCommission +
                commissionFinal.hupCommission +
                commissionFinal.autopayCommission +
                commissionFinal.addonCommission
              )?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : 0}*/}
            {formatToUSD(commissionFinal.postpaidCommission +
                commissionFinal.prepaidCommission +
                commissionFinal.hupCommission +
                commissionFinal.autopayCommission +
                commissionFinal.addonCommission || 0)}
   
        </span>
      </div>
    </div>
  );
};

export default Commissions;
